import { useMemo } from 'react';

// Native series formatters use the browser's locale. Series without their own formatter get the chart locale one.
export const useLocaleSeries = <T extends { valueFormatter?: unknown }>(
  series: readonly T[],
  valueFormatter: NonNullable<T['valueFormatter']>
) =>
  useMemo(
    () => series.map((item) => (item.valueFormatter === undefined ? { ...item, valueFormatter } : item)),
    [series, valueFormatter]
  );
